<template>
    <div>
        <h1>My Sightings</h1>
        <div class="sightings">
            <template v-if="!isLoading">
                <a
                    class="sightings-sighting"
                    v-for="sighting in sightings"
                    :key="sighting.id"
                    :sighting="sighting"
                    :href="sighting.sightingUrl"
                >
                    <div>
                        Sighting Date: {{ sighting.sightingDate }}<br />
                        Created Date: {{ sighting.createDate }}<br />
                        Project/Species: {{ sighting.species }}<br />
                        Project/Group: {{ sighting.projectGroupName }}<br />
                        Project/Report: {{ sighting.projectReportName }}<br />
                        Latitude/Longitude: {{ sighting.latitude }},
                        {{ sighting.longitude }}<br />
                        Location: {{ sighting.nearest }},
                        {{ sighting.nearestst }}
                        <br v-if="sighting.number > 0" />
                        <span v-if="sighting.number > 0">
                            Number: {{ sighting.number }}
                        </span>
                        <br
                            v-if="
                                sighting.duration &&
                                    sighting.duration != '00:00:00'
                            "
                        />
                        <span
                            v-if="
                                sighting.duration &&
                                    sighting.duration != '00:00:00'
                            "
                        >
                            Duration (Daylight): {{ sighting.duration }}
                        </span>
                        <br
                            v-if="
                                sighting.numberDuration &&
                                    sighting.numberDuration != '00:00:00'
                            "
                        />
                        <span
                            v-if="
                                sighting.numberDuration &&
                                    sighting.numberDuration != '00:00:00'
                            "
                        >
                            Duration (Number Sighted):
                            {{ sighting.numberDuration }}
                        </span>
                    </div>
                    <div>
                        <img
                            v-if="sighting.imageUrl"
                            :src="sighting.imageUrl"
                            alt=""
                        />
                    </div>
                </a>
            </template>
            <p v-else>
                Loading sightings
            </p>
        </div>
        <div v-if="showMore">
            <button name="buttonMore" @click="loadMore()">More</button>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            isLoading: true,
            sightings: [],
            customerId: '',
            email: '',
            page: 1,
            limit: 20,
            more: false
        }
    },
    computed: {
        showMore() {
            return this.more
        }
    },
    methods: {
        loadMore() {
            axios
                .post(process.env.VUE_APP_API_DOMAIN + '/sightings', {
                    userId: this.customerId,
                    userEmail: this.email,
                    page: this.page,
                    limit: this.limit
                })
                .then(({ data }) => {
                    this.isLoading = false

                    let sightings = this.sightings
                    data.sightings.forEach(function(sighting) {
                        sightings.push(sighting)
                    })

                    let offsetPage = this.page - 1
                    let sightingsLoaded = offsetPage * this.limit + this.limit
                    if (data.totalSightings > sightingsLoaded) {
                        this.more = true
                        this.page++
                    } else this.more = false
                })
        }
    },
    created() {
        const user = this.$store.state.user

        this.customerId = user.customerId
        this.email = user.email

        axios
            .post(process.env.VUE_APP_API_DOMAIN + '/sightings', {
                userId: this.customerId,
                userEmail: this.email,
                page: this.page,
                limit: this.limit
            })
            .then(({ data }) => {
                this.sightings = data.sightings
                this.isLoading = false

                let offsetPage = this.page - 1
                let sightingsLoaded = offsetPage * this.limit + this.limit
                if (data.totalSightings > sightingsLoaded) {
                    this.more = true
                    this.page++
                } else this.more = false
            })
    }
}
</script>
